import { SurveyMcqOption } from './survey-mcq-option.model';
import { SurveyQuestionType } from './survey-question-type.enum';
import { OrganisationDetails } from '../org-details.model';
import { Person } from '../person.model';
import { Organisation } from '../organisation.model';
/**
 * Created by tbhasme on 17-10-2017.
 */

export class SurveyResponse {
  id: number;
  entityId: number;
  entityName: string;
  questionText: string;
  helpText: string;
  type: number;
  required: boolean;
  options: SurveyMcqOption[];
  questionType: SurveyQuestionType;
  optionAnswer: number;
  openAnswer: string;
  responseOrganisation: Organisation;
  responsePerson: Person;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-response.model.ts